// extracted by mini-css-extract-plugin
export var luxury_season_details = "luxurySeason-module--luxury_season_details--c3959";